export const styleWanted = {
  top: "60%",
  right: "40%",
  position: "absolute",
  backgroundColor: "#ffffff",
  width: "30%",
  height: "2.5rem",
  borderRadius: "5px 0px 5px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "5px 5px 25px 0px #000000",
};
export const styleSeen = {
  top: "60%",
  right: "-25%",
  position: "absolute",
  backgroundColor: "#ffffff",
  width: "30%",
  height: "2.5rem",
  borderRadius: "0px 5px 0px 5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const styleRemoveWanted = {
  top: "60%",
  right: "40%",
  position: "absolute",
  backgroundColor: "#ffbf66",
  width: "30%",
  height: "2.5rem",
  borderRadius: "5px 0px 5px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const styleRemoveSeen = {
  top: "60%",
  right: "-25%",
  position: "absolute",
  backgroundColor: "#52cc99",
  width: "30%",
  height: "2.5rem",
  borderRadius: "0px 5px 0px 5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

// ----------------------------------------------

export const styleWantedPageMovie = {
  bottom: "10%",
  left: "43%",
  position: "absolute",
  backgroundColor: "#ffffff",
  width: "10%",
  height: "2.5rem",
  borderRadius: "5px 0px 5px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const styleSeenPageMovie = {
  bottom: "10%",
  right: "31%",
  position: "absolute",
  backgroundColor: "#ffffff",
  width: "10%",
  height: "2.5rem",
  borderRadius: "0px 5px 0px 5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const styleRemoveWantedPageMovie = {
  bottom: "10%",
  left: "43%",
  position: "absolute",
  backgroundColor: "#ffbf66",
  width: "10%",
  height: "2.5rem",
  borderRadius: "5px 0px 5px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const styleRemoveSeenPageMovie = {
  bottom: "10%",
  right: "31%",
  position: "absolute",
  backgroundColor: "#52cc99",
  width: "10%",
  height: "2.5rem",
  borderRadius: "0px 5px 0px 5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
